import { render, staticRenderFns } from "./AllPolicies.vue?vue&type=template&id=36c1e82c&"
import script from "./AllPolicies.vue?vue&type=script&lang=js&"
export * from "./AllPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports